import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import MnzTag from "../img/moonozTag.svg";
import '../style/navBar.css';

window.onscroll = function (e) {
    e.preventDefault();

    let scroll = window.scrollY;

    // console.log(scroll);
    var Scroll = document.querySelector("#navBar-Scroll")

    var navLeft = document.querySelector("#nav-link-left");
    var navRight = document.querySelector("#nav-link-right");
    var logo = document.getElementById("logo");

    if (scroll > 300) {
        Scroll.classList.add("bg-menu");
        navLeft.classList.add("nav-scroll");
        navRight.classList.add("nav-scroll");
        logo.classList.add("logo");
        logo.classList.add("animate__fadeInUp");
    } else {
        Scroll.classList.remove("bg-menu");
        navLeft.classList.remove("nav-scroll");
        navRight.classList.remove("nav-scroll");
        logo.classList.remove("logo");
    }
};



function NavBar() {




    return (
        <>
            <Navbar id="navBar-Scroll" className="navbar navBar" expand="lg" fixed="top">
                <Container>
                    <a href="/" class="nav-width" >

                        <img src={MnzTag} alt="" className="mobile-logo animate__animated animate__fadeIn" />
                    </a>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" data-toggle="collapse" className="navbar-dark ml-auto" variant="navbar-dark" data-target="#menu-Navbar" />
                    <Navbar.Collapse id="basic-navbar-nav" >
                        <Nav className="collapse navbar-collapse justify-content-center" id="menu-Navbar">
                            <ul id="nav-link-left" className="navbar-nav">
                                <li className="nav-item">
                                    <Link className="nav-link" to="/">Home</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/AboutMe">About Me</Link>
                                </li>
                            </ul>

                            <img src={MnzTag} alt="" id="logo" className="animate__animated" width="8%" />




                            <ul id="nav-link-right" className="navbar-nav">
                                <li className="nav-item">
                                    <Link className="nav-link" to="/Disenoz">DISENOZ</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/ContactMe">CONTACT ME</Link>
                                </li>
                            </ul>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>

    );
}

export default NavBar;
